import { font } from '@metro-ui/tokens/js';
export var fontStack = "\n  font-family: ".concat(font.stack, ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n");
//# sourceMappingURL=fontStack.js.map